<template>
  <div
    :style="{ height: minHheight == 1 ? '476px' : '150px' }"
    class="manualItemcontent"
    @touchmove.stop
  >
    <form action="/">
      <van-search
        v-model="value"
        show-action
        shape="round"
        :placeholder="inpuTell"
        @search="onSearch"
        @cancel="onCancel('1')"
        @focus="onFocus('1')"
        @blur="onBlur('1')"
      >
        <template #action>
          <div @click="onSearch">搜索</div>
        </template>
      </van-search>
    </form>
    <div class="tell" v-if="searchTabShow && noNum" style="color: #999">
      暂无结果，请重新输入!
    </div>
    <div
      class="tell"
      v-if="result.length > 0"
      :style="{ color: num === 10 ? '#f33b45' : '#999' }"
    >
      已选 {{ num }} 个，最多选10个
    </div>
    <div class="searchBg" v-if="searchTabShow">
      <div class="searUl" v-if="searCh">
        <van-checkbox-group v-model="result" v-if="searCh" :max="10">
          <van-cell-group>
            <van-cell
              v-for="(item, key) in searchList"
              clickable
              :key="key"
              :title="item.name"
              :data-name="item"
              @click="toggle(item)"
            >
              <template #right-icon>
                <van-checkbox
                  shape="square"
                  :name="key"
                  ref="checkboxes"
                  :disabled="ifDisable"
                />
              </template>
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>
      </div>
    </div>
    <van-checkbox-group v-model="result" v-if="!searchTabShow" :max="10">
      <van-cell-group>
        <van-cell
          v-for="(item, key) in newList"
          clickable
          :key="key"
          :title="item.name"
          :data-name="item"
          @click="toggle(item)"
        >
          <template #right-icon>
            <van-checkbox
              ref="checkboxes"
              :disable="ifDisable"
              :name="key"
              shape="square"
            />
          </template>
        </van-cell>
      </van-cell-group>
    </van-checkbox-group>
    <div class="confirmItemMbtn" v-if="source == 2">
      <van-button type="primary" @click="submitItme">确定</van-button>
    </div>
  </div>
</template>
<script>
import {
  _getIllness, //疾病
} from "@/api/login";

export default {
  name: "Choice",
  components: {},

  props: {
    onlineChild: {
      type: Array,
      default: () => [],
    },
    onClass: {
      type: String,
      default: "",
    },
    typeRecord: {
      type: String,
      default: "",
    },
    sourceFlag: {
      type: String,
      default: "",
    },
    minHheight: {
      type: Number,
      default: 1,
    },
    currentName: {
      type: Array,
      default: () => [],
    },
    apiType: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      inpuTell: "请输入搜索关键词",
      jyList: [],
      //检验项目选中数据
      result: [],
      value: "",
      searchTabShow: false, //显示搜索模块
      hisTory: false, //显示搜索历史
      searCh: false, //显示模糊查询列表
      historyList: [], //查询历史列表

      allList: this.onlineChild, //所有的数据
      fatherClass: this.onClass,
      codeType: this.typeRecord,
      newList: {},
      searchResult: [], //搜索选择的结果
      searchList: {}, //搜索列表
      ifDisable: false, //监测是否禁止点击
      num: 0,
      noNum: false,
      source: this.sourceFlag,
      resultName: this.currentName,
      chooseArr: [],
    };
  },
  //监听数据变化
  watch: {
    //父组件传过来的值
    onlineChild(val) {
      this.allList = val;
      this.allList.forEach((i) => {
        this.newList[i.name] = i;
      });
    },
    onClass(val) {
      this.fatherClass = val;
    },
    typeRecord(val) {
      this.codeType = val;
    },
    //监听搜索框的值
    value: function () {
      this.noNum = false;
    },
    //监听已选数组
    result: function () {
      if (this.result.length > 11) {
        this.ifDisable = true;
        this.num = this.result.length;
      } else {
        this.ifDisable = false;
      }
      this.num = this.result.length;
    },
    sourceFlag(val) {
      this.source = val;
    },
    currentName(val) {
      this.resultName = val;
    },
  },
  mounted() {
    this.value = "";
    this.searchTabShow = false; //显示搜索模块
    this.hisTory = false; //显示搜索历史
    this.searCh = false; //显示模糊查询列表
    this.allList = this.onlineChild;
    for (let i = 0; i < this.allList.length; i++) {
      let item = this.allList[i];
      if (item.id == "") {
        delete this.allList[i];
      }
    }
    this.allList.sort(this.compare("status"));
    this.noNum = false;
    this.searchTabShow = false;
    if (this.chooseArr.length) {
      this.chooseArr.forEach((item) => {
        this.allList.unshift(item);
      });
      this.newList = {};
      this.allList.forEach((i) => {
        this.newList[i.name] = i;
      });
    } else {
      this.allList.forEach((i) => {
        this.newList[i.name] = i;
      });
    }
    this.result = [];
    this.statusNum();
  },
  methods: {
    compare(property) {
      return function (a, b) {
        var value1 = a[property];
        var value2 = b[property];
        return value2 - value1;
      };
    },
    toggle(item) {
      this.$nextTick(() => {
        let checkbox = this.$refs.checkboxes.find((c) => c.name == item.name);
        if (this.result.length === 10 && item.id != "wu") {
          if (!checkbox.checked) {
            this.$toast("最多选10个");
          }
          return;
        }
        if (item.name === "无") {
          this.result = this.result.filter((item) => item === "无");
        } else {
          this.result = this.result.filter((item) => item !== "无");
        }
      });
    },
    //处理回显逻辑
    statusNum() {
      this.result = this.resultName;
      this.num = this.result.length;
    },
    //检验 确认新增项目/子项
    submitItme() {
      let giveArray = [];
      this.allList.forEach((item) => {
        item.status = false;
        this.result.forEach((i) => {
          if (item.name === i) {
            item.status = true;
            giveArray.push(item);
          }
        });
      });
      let listArr = giveArray.filter((item) => item.status);
      let listName = [];
      listArr.map((item) => {
        listName.push(item.name);
      });
      this.chooseArr = [];
      this.allList.forEach((item, index) => {
        listName.forEach((n) => {
          if (n == item.name) {
            this.chooseArr.push(item);
            this.allList.splice(index, 1);
          }
        });
      });
      this.$emit("getChoiceData", listArr, listName);
    },
    onSearch(value) {
      this.searchTabShow = true;
      if (this.value === "") {
        this.searchTabShow = false;
        return false;
      }
      if (
        this.fatherClass === "diet" ||
        this.fatherClass === "food" ||
        this.fatherClass === "foods" ||
        this.fatherClass === "add"
      ) {
        _getBaseDietDate({
          keyWord: this.value.replace(/\s*/g, ""),
          id: this.codeType,
        }).then((res) => {
          if (res.code === 200) {
            if (res.data.total > 0) {
              //多选回显
              this.noNum = false;
              this.searCh = true;
              this.searchResult = [];
              this.searchResult = this.result;
              this.searchList = {};
              this.jyList = res.data.records;
              let code = [];
              this.allList.map((item) => {
                code.push(item.name);
              });
              this.jyList.forEach((i) => {
                i.status = false;
                this.searchList[i.name] = i;
                if (code.indexOf(i.name) === -1) {
                  //去重
                  this.allList.push(i);
                }
              });
            } else {
              this.searchList = {};
              this.noNum = true;
              //this.$toast("暂无结果，请重新输入！");
            }
            //this.searchTabShow = false;
          }
        });
      } else if (
        this.fatherClass === "current" ||
        this.fatherClass === "chuanran" ||
        this.fatherClass === "yichuan"
      ) {
        _getIllness({
          currentPage: 1,
          pageSize: 1000,
          queryData: {
            dictCode: this.apiType === 1 ? "XBS-SYSA" : "JZBS-SYSA",
            name: this.value.replace(/\s*/g, ""),
          },
        }).then((res) => {
          if (res.code === 200) {
            if (res.data.total > 0) {
              //多选回显
              this.noNum = false;
              this.searCh = true;
              this.searchResult = [];
              this.searchResult = this.result;
              this.searchList = {};
              this.jyList = res.data.records;
              let code = [];
              this.allList.map((item) => {
                code.push(item.name);
              });
              this.jyList.forEach((i) => {
                i.status = false;
                this.searchList[i.name] = i;
                if (code.indexOf(i.name) === -1) {
                  //去重
                  this.allList.push(i);
                }
              });
            } else {
              this.searchList = {};
              this.noNum = true;
              //this.$toast("暂无结果，请重新输入！");
            }
            //this.searchTabShow = false;
          }
        });
      }
    },
    //点击取消或者添加
    onCancel() {
      this.searchTabShow = false;
      this.searchResult = [];
      this.searchList = {};
    },
    //获取焦点事件
    onFocus(id) {
      this.searchTabShow = true;
    },
    onBlur() {
      if (this.searchTabShow && !this.searCh) {
        this.searchTabShow = false;
      }
    },
  },
};
</script>
<style scoped lang="less">
.tell {
  width: 100%;
  margin-bottom: 10px;
  color: #999;
  text-indent: 20px;
  font-size: 12px;
}

.van-search__content {
  margin-right: 10px;
}

/deep/ .van-tabs__line {
  background-color: #00cad9;
}

.van-action-sheet {
  overflow: hidden;
}

.van-checkbox {
  width: 90%;
  justify-content: flex-end;
}

.van-cell__title {
  white-space: nowrap;
}

.van-checkbox-group {
  padding-bottom: 100px; //新增
  // height:400px;//新增
  box-sizing: border-box;
  overflow: scroll;
}

/deep/ .van-field__clear {
  color: #c8c9cc;
  font-size: 24px !important;
  cursor: pointer;
}

.addbtnBg {
  width: 100%;
  height: 34px;
  line-height: 34px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 0 10px 0;
  padding-top: 20px;
  position: relative;

  .imgbg {
    img {
      vertical-align: middle;
      width: 34px;
      height: 34px;
    }
  }

  .addBtn {
    /deep/ .van-button {
      width: 300px;
      height: 34px;
      border: none;
      box-shadow: 0px 2px 7px 0px rgba(208, 208, 208, 0.5);
      border-radius: 4px;
      font-size: 14px;
      color: #333;
      /deep/ .van-icon-plus::before {
        content: "\F0A2";
        font-weight: bold;
        color: #00ca9d;
      }
    }
  }
}

.idelete {
  margin-left: 0;
  width: 16px;
  height: 16px;
  margin-top: 12px;
  margin-right: 5px;
}

/deep/ .van-tabs__nav--line {
  width: 250px;
}

.fcontent {
  width: 345px;
  height: auto;
  background: #fff;
  box-shadow: 0px 2px 7px 0px rgba(208, 208, 208, 0.5);
  border-radius: 4px;

  .fdiv {
    display: flex;
    margin: 12px 0;
    border-bottom: 1px solid #eaeaea;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    padding-right: 15px;

    .ibtn {
      width: 8px;
      height: 12px;
      display: inline-block;
    }

    .zhankai {
      margin-left: 5px;
    }

    .idelete {
      margin: 0 auto;
      width: 16px;
      height: 16px;
    }

    .ispan {
      display: inline-block;
      width: 150px;
      margin-bottom: 10px;
      height: 20px;
      margin-top: 10px;
      color: #00ca9d;
      font-weight: 400;
      padding-left: 12px;
      border-left: 4px solid #00ca9d;
    }

    .idspan {
      display: inline-block;
      height: 30px;
      width: 30px;
    }

    .imspan {
      display: inline-block;
      width: 130px;
      text-align: right;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }

    .imsspan {
      display: flex;
      margin-left: 20px;
      text-align: right;
      align-items: center;
    }

    .mleft {
      margin-left: 76px;
    }

    .isMleft {
      margin-left: 60px;
    }
  }

  .reportCheckF {
    min-height: 28px;
    line-height: 28px;
    display: flex;
    background: linear-gradient(315deg, #47ecc7 0%, #00ca9d 100%);

    img {
      width: 0.4rem;
      height: 0.4rem;
      display: inline-block;
      margin-left: 0.1rem;
    }

    > li {
      padding-left: 16px;
      text-align: left;
      display: inline-block;
      font-size: 14px;
      color: #fff;
      height: 1rem;
    }
  }

  .reportCheckC {
    background: #fff;
    line-height: 40px;
    padding: 0 10px;
    height: 60px;
    margin-top: 6px;
    border-bottom: 1px solid #eaeaea;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    position: relative;

    .ierror {
      position: absolute;
      left: 37px;
      bottom: 0px;
    }

    > li {
      font-size: 12px;
      color: #333;
      padding-left: 0;

      .iarrow {
        width: 13px;
        height: 12px;
      }
    }

    .idspan {
      display: inline-block;
      height: 20px;
      width: 20px;

      > img {
        width: 16px;
        height: 16px;
      }
    }

    .lname {
      width: 42%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .ivalue {
      min-width: 35%;
      text-align: right;
    }

    .ivalues {
      display: flex;
      height: 1rem;
      align-items: center;
    }

    .izbtn {
      display: flex;
      height: 40px;
      float: right;
      position: absolute;
      right: 0;

      .izsp {
        width: 60px;
        height: 40px;
        text-align: right;
        box-sizing: border-box;
        padding-right: 18px;

        > img {
          width: 8px;
          height: 12px;
        }
      }
    }

    .lname2 {
      width: 108px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}

.manualItemcontent {
  //此处全是新增
  width: 375px;
  height: 472px;
  background: #fff;
  border-radius: 25px 25px 0px 0px;

  .searchBg {
    width: 100%;
    height: 200px;
    position: relative;

    .hisTab {
      width: 100%;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 15px;
      box-sizing: border-box;
      padding: 0 20px;

      .van-icon {
        font-size: 20px;
      }
    }

    .hisUl {
      width: 100%;
      min-height: 100px;
      display: flex;
      flex-wrap: wrap;
      box-sizing: border-box;
      padding: 5px 20px;

      li {
        width: auto;
        border-radius: 15px;
        padding: 0px 10px;
        height: 30px;
        line-height: 30px;
        background: #f7f8fa;
        margin: 0 5px 5px 0;
        font-size: 13px;
      }
    }

    .searUl {
      position: absolute;
      width: 100%;
      min-height: 300px;
      box-sizing: border-box;
      padding: 5px 20px;
      top: 0;
      left: 0;
      background: #fff;

      li {
        width: 100%;
        font-size: 14px;
        color: #666;
        line-height: 40px;
        border-bottom: 1px solid #eee;
      }
    }
  }

  .confirmItemMbtn {
    width: 100%;
    height: 110px;
    background: #fff;
    box-shadow: 0px 9px 20px 0px rgba(103, 103, 103, 0.5);
    position: fixed;
    left: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    /deep/ .van-button {
      border: none;
      width: 266px;
      height: 38px;
      // background: #8b6ffc;
      background: linear-gradient(180deg, #17e1eb, #24bffb);
      // border-color: #8b6ffc;
      border-radius: 20px;
    }
  }
}
</style>
